/*!
 * Shop detail component
 *
 * wpdeps=vue-js,hashboard-rest,hb-components-loading
 */

/* global Vue:false */
/* global MakibishiShopDetail: false */

"use strict";

Vue.component( 'shop-detail', {
  props: {
    id: {
      type: Number,
      required: true
    },
    shop: {
      type: Object,
      default: null
    },
    showDetached: {
      type: Boolean,
      default: false
    },
    table: {
      type: String,
      default: 'table,shop-detail-table'
    }
  },
  data: function(){
    return {
      shop: null,
      loading: false
    };
  },
  filters: {
    tel: function (value) {
      if (!value){
        return '';
      }
      value = value.toString();
      return value.replace(/^(\+\d{2})(\d+)$/, '$1 0$2');
    }
  },
  methods: {
    detach: function(){
      if(window.confirm(this.labels.confirm)){
        // Detach.
        this.$emit('shop-detached', this.shop);
      }
    },
  },
  computed: {
    href_tel: function() {
      return this.shop ? `tel:${this.shop.support_phone}` : '';
    },
    href_mail: function() {
      return this.shop ? `mailto:${this.shop.support_email}` : '';
    },
    labels: function() {
      return MakibishiShopDetail;
    },
    tableClass: function() {
      return this.table.split( ',' ).map( ( str ) => {
        return str.trim();
      });
    }
  },
  mounted: function(){
    let self = this;
    if(!this.shop){
      this.loading = true;
      jQuery.hbRest('GET',  `makibishi/v1/owner/${this.id}`).done(function(response){
        self.shop = response;
      }).fail(jQuery.hbRestError()).always(function(){
        self.loading = false;
      });
    }
  },
  template: `
    <div :class="this.tableClass">
       <table v-if="shop" class="table shop-detail-table">
         <tbody>
            <tr>
                <th>{{labels.business_name}}</th>
                <td>{{shop.business_name}}</td>
            </tr>
            <tr>
                <th>URL</th>
                <td>
                    <a class="shop-detail-link" v-if="shop.business_url" :href="shop.business_url" target="_blank">{{shop.business_url}}</a>
                    <span v-else><i class="material-icons text-error">error</i> {{labels.not_set}}</spanv>
                </td>
            </tr>
            <tr>
                <th>{{labels.business_address}}</th>
                <td>
                    <span v-if="shop.support_address">
                        <small>〒{{shop.support_address.postal_code}}</small><br />
                        {{shop.support_address.country}}
                        {{shop.support_address.state}}
                        {{shop.support_address.city}}
                        {{shop.support_address.line1}}<br />
                        {{shop.support_address.line2}}
                    </span>
                    <span v-else><i class="material-icons text-error">error</i> {{labels.not_set}}</spanv>
                </td>
            </tr>
            <tr>
                <th>{{labels.business_phone}}</th>
                <td>
                    <a class="shop-detail-link" v-if="shop.support_phone" :href="href_tel" target="_blank">{{ shop.support_phone | tel }}</a>
                    <span v-else><i class="material-icons text-error">error</i> {{labels.not_set}}</spanv>
                </td>
            </tr>
            <tr>
                <th>{{labels.business_mail}}</th>
                <td>
                    <a class="shop-detail-link" v-if="shop.support_email" :href="href_mail">{{shop.support_email}}</a>
                    <span v-else><i class="material-icons text-error">error</i> {{labels.not_set}}</spanv>
                </td>
            </tr>
            <tr>
                <th>{{labels.business_status}}</th>
                <td>
                    <span v-if="shop.charges_enabled" class="shop-status text-success">
                        <i class="material-icons">check_circle</i> O.K.
                    </span>
                    <span v-else class="shop-status text-danger">
                        <i class="material-icons">report</i> {{labels.invalid}}
                    </span>
                </td>
            </tr>
         </tbody>
        </table>
        <p v-if="showDetached">
            <button v-if="shop && shop.detachable" @click.prevent="detach" class="btn btn-outline-danger">{{labels.disconnect}}</button>
            <button v-if="shop && !shop.detachable" class="btn disabled">{{labels.disconnect}}</button>
            
            <a v-if="!shop" class="btn btn-primary" :href="labels.connect_url + '?brand=' + id">{{labels.connect}}</a>
        </p>
        <hb-loading :loading="loading"></hb-loading>
    </div>
  `

} );
